import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/icons/List';

import './CartSummaryTextil.scss';

import { cartItemsArrayPropTypes } from 'helpers/propTypes';
import { getLocalStorage } from 'helpers/storage';
import { getTextilQuantityAndTotal } from 'helpers/prices';
import { formatCurrencyARS, toNumericValue } from 'helpers/currency';

const getUnitLabel = (unitType) => {
  switch (unitType) {
    case 'kg':
      return 'Kgs';
    case 'metro':
      return 'Metros';
    default:
      return 'Unidades';
  }
};

const CartSummaryTextil = ({
  items, shippingText, coupon, subTotEnv, subtotal, cuotasMP, onOpenPaymentModal, showMPButton,
  paymentMethods,
}) => {
    const hasInstallments = cuotasMP && cuotasMP.length > 0;
    const findProductWholesale = (id, item) => {
        const product = item.product_wholesaler.find((prod) => prod.id === id);
        return product.price * product.quantity;
    };
    
    const findIDProductWholesale = (subItem, item) => {
        const nonEmptyArrays = Object.values(subItem || {})
          .filter((v) => Array.isArray(v) && v.length > 0);
        const firstArray = nonEmptyArrays[0];
        if (!firstArray) {
          const currentPrice = item.sale > 0 ? item.sale : item.price;
          return `Precio - ${formatCurrencyARS(currentPrice)}`;
        }
      
        const firstObject = firstArray[0];
        const id = firstObject?.wholesale?.id ?? 0;
        if (id > 0) {
          const product = item.product_wholesaler.find((p) => p.id === id);
          return `Precio por ${firstObject.wholesale.quantity} - ${formatCurrencyARS(product.price * product.quantity)}`;
        }
        const currentPrice = item.sale > 0 ? item.sale : item.price;
        return `Precio - ${formatCurrencyARS(currentPrice)}`;
      };
    
    const renderDescriptions = (descriptions, colors, item, descriptionId) => {
        const color = colors.find(
        ({ stock_description_id }) => stock_description_id === Number(descriptionId),
        );
        return !!descriptions.length && (
        <li key={`${item.id}-${descriptionId}`}>
            <strong style={{ color: color?.stock_descriptions?.rgb }}>
            {color?.stock_descriptions?.name}
            </strong>
            {' - '}
            {descriptions.map(({ description, quantity: amount }, index) => (
            <span className="cart-item-description" key={`${item.id}-${description.id}`}>
                {description.id === color?.id
                ? amount
                : `${description.stock_descriptions.name}: ${amount}${index === descriptions.length - 1 ? '' : ', '}`}
            </span>
            ))}
        </li>
        );
    };
    
    const itemsUseMetros = items.filter(({ item }) => item?.usoMetros);
    const itemsNoMetros = items.filter(({ item }) => !item?.usoMetros);    

  const discount = getLocalStorage('discount');
  const discountValue = discount === null ? null : toNumericValue(discount);
  const subtotalValue = toNumericValue(subtotal);
  const percentageOrAmount = coupon?.percentage
    ? (coupon.percentage / 100) * subtotalValue
    : toNumericValue(coupon?.amount || 0);
  const totalValueWithDiscount = (discountValue - percentageOrAmount) > 0
    ? discountValue - percentageOrAmount
    : 0;
  const totalValueWithPercetage = subtotalValue - percentageOrAmount;

  const totalFinal = (
    discount === null
      ? subtotalValue
      : coupon?.percentage
        ? totalValueWithPercetage
        : totalValueWithDiscount
  ) + toNumericValue(subTotEnv);

  const paymentRows = Array.isArray(paymentMethods)
    ? paymentMethods.map(m => {
        const rawPercent = toNumericValue(m.percent);
        const methodPercent = Math.min(1, Math.max(0, rawPercent));
        const label = m.name || m.code || 'Medio de pago';

        const baseAuto = (m.allow_discount && discountValue !== null)
            ? discountValue
            : subtotalValue;

        const baseConCupon = Math.max(0, baseAuto - percentageOrAmount);
        const finalAmount = (baseConCupon + toNumericValue(subTotEnv)) * (1 - methodPercent);
        
        return { 
            key: m.code || label, 
            label, 
            percent: methodPercent, 
            amount: finalAmount,
            isAutoAllowed: !!m.allow_discount 
        };
      })
    : [];


  return (
    <div className="container" data-testid="cart-summary-component">
      <div className="row">
        <div className="form-container">
          <Avatar className="avatar">
            <List />
          </Avatar>
          <h4>Resumen de la compra</h4>
          <div className="summary-items">
            {itemsUseMetros.map(({ item, quantity }) => {
              if (!item) return null;

              const { total, quantity: adjustedQuantity } = getTextilQuantityAndTotal(item, quantity);

              return (
                <div key={item.id}>
                  <div className="d-flex flex-row">
                    <div className="summary-item-image">
                      <img src={item.image1} alt={item.name} />
                    </div>
                    <div className="summary-item-info">
                      <ul>
                        <li className="d-flex flex-row">
                          <span className="summary-item-title">{item.name}</span>
                        </li>
                        <li>
                          <span className="summary-item-description">{item.description}</span>
                        </li>
                        <li>
                          <span className="summary-item-price price-text">
                            Total: {formatCurrencyARS(total)}
                          </span>
                        </li>
                        <li>
                          <span className="summary-item-title">
                            Cantidad elegida: {adjustedQuantity} {getUnitLabel(item?.unit_type)}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="separator" />
                </div>
              );
            })}
            {itemsNoMetros.map(({ item, quantity, colors, subItems, subItemsDescriptions }) => {               
                return(
                    !!item && (
                        <div key={`n-${item.id}`}>
                        <div className="d-flex flex-row">
                            <div className="summary-item-image">
                            <img src={item.image1} alt={item.name} />
                            </div>
                            <div className="summary-item-info">
                            <ul>
                                <li className="d-flex flex-row">
                                <span className="summary-item-title">{item.name}</span>
                                </li>
                                <li>
                                <span className="summary-item-description">{item.description}</span>
                                </li>

                                {colors && (
                                <div className="descriptions-container-cart-summary">
                                    {Object.values(subItemsDescriptions || {}).some(
                                    (value) => typeof value === 'object' && Object.keys(value).length > 0
                                    ) && (
                                    <>
                                        {Object.values(subItemsDescriptions || {})
                                        .filter((sd) => sd && typeof sd === 'object' && Object.keys(sd).length > 0)
                                        .map((subItemDescription, idx) => (
                                        <div className="precios-container" key={`${item.id}-subdesc-${idx}`}>
                                            {Object.keys(subItemDescription).length > 0 && (
                                            <>
                                                <span className="title-description search-item">
                                                {findIDProductWholesale(subItemDescription, item)}
                                                </span>
                                                {Object.entries(subItemDescription).map(
                                                ([descriptionId, descriptionArray]) =>
                                                    renderDescriptions(descriptionArray, colors, item, descriptionId)
                                                )}
                                            </>
                                            )}
                                        </div>
                                        ))}
                                    </>
                                    )}
                                </div>
                                )}

                                {subItems?.length > 0 && (
                                <>
                                    {subItems.map((subItem, idx) => (
                                    <div className="precios-container" key={`${item.id}-wh-${idx}`}>
                                        <span className="title-description search-item">
                                        {subItem.wholesale.id > 0 ? `Precio por ${subItem.wholesale.quantity} -` : 'Precio  -'}
                                        </span>
                                        <span className="summary-item-price price-text">
                                        {formatCurrencyARS(
                                          subItem.wholesale.id > 0
                                            ? findProductWholesale(subItem.wholesale.id, item)
                                            : item.price
                                        )}
                                        </span>
                                        <li>
                                        <span className="summary-item-title">
                                            {`Cantidad: ${subItem.quantity}`}
                                        </span>
                                        </li>
                                    </div>
                                    ))}
                                </>
                                )}

                                {!(item.product_wholesaler?.length > 0) &&
                                (item.stock_product_descriptions?.length === 0) && (
                                    <>
                                    <div className="precios-container">
                                        <span className="title-description search-item">
                                        Precio  -
                                        </span>
                                        <span className="summary-item-price price-text">
                                        {(item.product_wholesaler?.length === 0) &&
                                            formatCurrencyARS(item.sale || item.price)}
                                        {!!item.sale && (item.product_wholesaler?.length === 0) && (
                                            <span>{formatCurrencyARS(item.price)}</span>
                                        )}
                                        {(item.product_wholesaler?.length > 0) &&
                                            formatCurrencyARS(item.price)}
                                        </span>
                                    </div>
                                    <li>
                                        <span className="summary-item-title">
                                        {`Cantidad: ${quantity}`}
                                        </span>
                                    </li>
                                    </>
                                )}
                            </ul>
                            </div>
                        </div>
                        <div className="separator" />
                        </div>
                    )
                );
            }
            )}
          </div>
          <ul className="summary-subtotal">
            <li>
              Subtotal:
              {discount === null
                ? (
                  <span className="float-right">
                    {formatCurrencyARS(subtotalValue)}
                  </span>
                )
                : (
                  <del className="float-right">
                    {formatCurrencyARS(subtotalValue)}
                  </del>
                )}
            </li>
            <li>
              Descuentos
              <span className="float-right">
                {
                  !coupon ? (
                    discount != null
                    && (
                      <>
                        {getLocalStorage('percentage')}%
                      </>
                    )
                  ) : (
                    <>
                      {discount != null ? (`CUPÓN ${coupon.percentage ? (`${coupon.percentage}%`) : (`${formatCurrencyARS(coupon.amount)} y ${getLocalStorage('percentage')}%:`)} `) : (`CUPÓN ${coupon.percentage ? (`${coupon.percentage}%`) : (`${formatCurrencyARS(coupon.amount)}`)} `)}
                    </>
                  )
                }
              </span>
            </li>
            <li>
              Costo de envío:
              <span className="float-right">
                {shippingText}
              </span>
            </li>
            <div className="separator" />
            <li>
                Total:
                <span className="float-right">
                    {formatCurrencyARS(totalFinal)}
                </span>
            </li>
            {hasInstallments && showMPButton &&(
              <div 
                className="pt-payment-methods-link" 
                onClick={onOpenPaymentModal}
                style={{ marginTop: '8px', cursor: 'pointer', color: '#3483fa', fontSize: '14px', fontWeight: '500' }}
              >
                Ver bancos con cuotas sin interés
              </div>
            )}
            {!!paymentRows.length && (
              <div style={{ marginTop: 16, padding: '12px', background: '#f8f9fa', borderRadius: '8px' }}>
                <div style={{ fontWeight: 600, marginBottom: 8, fontSize: '13px', borderBottom: '1px solid #ddd' }}>
                    Totales según medio de pago:
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {paymentRows.map(r => (
                    <li key={r.key} style={{ padding: '6px 0', borderBottom: '1px solid #eee' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>
                          {r.label}
                          {r.percent > 0 && <small style={{ color: '#28a745', marginLeft: '5px' }}>(-{(r.percent * 100).toFixed(0)}%)</small>}
                        </span>
                        <strong>{formatCurrencyARS(r.amount)}</strong>
                      </div>
                      
                      {!r.isAutoAllowed && discount !== null && (
                        <div style={{ fontSize: '10px', color: '#666', fontStyle: 'italic' }}>
                          * No incluye descuento automático.
                        </div>
                      )}
                      {r.isAutoAllowed && discount !== null && (
                        <div style={{ fontSize: '10px', color: '#28a745' }}>
                          * Incluye descuento automático aplicado.
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

CartSummaryTextil.defaultProps = {
  coupon: null,
};

CartSummaryTextil.propTypes = {
  items: cartItemsArrayPropTypes.isRequired,
  shippingText: PropTypes.string.isRequired,
  coupon: PropTypes.shape({
    id: PropTypes.number,
    percentage: PropTypes.number,
    amount: PropTypes.number,
  }),
  subTotEnv: PropTypes.number.isRequired,
};

export default CartSummaryTextil;
